import { getEnvironment } from '@minecraft.environment';

const env = getEnvironment();

export const AUDIO_THUMBNAIL_SRC = `${env.CDN_URL}/images/icons/b21/audio-thumbnail.svg`;
